import styled from 'styled-components'

export default styled.ul`
  margin: 0;
  padding: 0;
`
